import React from 'react';
import { PRODUCTS, PACKS_OF_4, PACKS_OF_8 } from '../../products';
import { useCart } from '../../context/CartContext';
import { PackCard } from './PackCard';
import { ProductCarousel } from './ProductCarousel';
import { Reveal } from '../common/Reveal';

export function Products() {
  const { addItem } = useCart();

  return (
    <section id="products" className="section products-section">
      <div className="container">
        {/* <div className="section-label">Our Products</div> */}
        <h2>Choose Your Kiane</h2>
        <p className="section-intro">
          Two delicious flavours, handcrafted for nourishing mornings. Pick your favourite or try both!
        </p>

        {/* Individual Products */}
        <div className="products-grid">
          {PRODUCTS.map((p, i) => (
            <Reveal key={p.id} delay={i * 100}>
              <div className="product-card">
                {p.mrp && (
                  <span className="discount-side-banner">
                    {Math.round((p.mrp - p.price) / p.mrp * 100)}% off
                  </span>
                )}
                <div className="product-img-wrap">
                  <ProductCarousel images={p.images} alt={p.name} />
                  <span className="product-badge">{p.badge}</span>
                </div>
                <div className="product-info">
                  <h3 className="product-name">{p.name}</h3>
                  <div className="product-price-row">
                    <span className="product-price">₹{p.price}</span>
                    {p.mrp && <span className="product-mrp">₹{p.mrp}</span>}
                  </div>
                  <div className="product-price-note">per pack · {p.weight}g</div>
                  <button
                    className="btn-primary btn-sm btn-cart"
                    onClick={() => addItem({ id: p.id, name: p.name, price: p.price, image: p.image })}
                  >
                    🛒 Add to Cart
                  </button>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Pack of 4 */}
        <div className="packs-heading">
          <span className="packs-size-label">Pack of 4</span>
          <p className="packs-size-note">Bundle &amp; save — great for regular mornings</p>
        </div>
        <div className="packs-grid">
          {PACKS_OF_4.map((pk, i) => (
            <Reveal key={pk.id} delay={i * 100}>
              <PackCard pack={pk} />
            </Reveal>
          ))}
        </div>

        {/* Pack of 8 */}
        <div className="packs-heading">
          <span className="packs-size-label">Pack of 8</span>
          <p className="packs-size-note">Maximum savings — never run out of your favourite</p>
        </div>
        <div className="packs-grid">
          {PACKS_OF_8.map((pk, i) => (
            <Reveal key={pk.id} delay={i * 100}>
              <PackCard pack={pk} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
